import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialUIModule } from '@app/shared/modules/material-ui/material-ui.module';
import { PrimengModule } from '@app/shared/modules/primeng.module';
import { AlertService } from '@core/services/alert.service';
import { DataStoreService } from '@core/services/data-store.service';
import { PageHeaderComponent } from './modules/page-header/page-header.component';
import { RouterLink } from '@angular/router';

@NgModule({
  imports: [CommonModule, PrimengModule, MaterialUIModule, ReactiveFormsModule, RouterLink],
  declarations: [PageHeaderComponent],
  exports: [PageHeaderComponent],
  providers: [AlertService, DataStoreService]
})
export class SharedModule {
  static forRoot(): any[] | import('@angular/core').Type<any> | import('@angular/core').ModuleWithProviders<any> {
    throw new Error('Method not implemented.');
  }
}
